<template>
    <div v-loading="loading" class="poPage">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="日期：" required>
                    <el-date-picker 
                        style="width:120px;"
                        @change="search"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月（必填）">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="地区：">
                    <el-select v-model="formInline.region" clearable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in regionList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售：" v-if="curRole=='admin'">
                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in salesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合作伙伴：" v-if="curRole=='admin'||curRole=='sales'">
                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in agentsList"
                            :key="item.agent_id"
                            :label="item.company"
                            :value="item.agent_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="APN_ID：" v-if="curRole=='admin'||curRole=='sales'">
                    <el-input v-model="formInline.agent_id" clearable style="width:120px" @change="search" placeholder="输入APN_ID查询"></el-input>   
                </el-form-item>
                <el-form-item><el-button  @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item><el-button  @click="reset" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item>
                    <el-button  @click="selected.length>0?downloadPOByUrl(1):downloadPOByUrl(2)" type="primary" icon="Download">下载PO</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button  @click="selected.length>0?downloadInvoiceByUrl(1):downloadInvoiceByUrl(2)" type="primary" icon="Download">下载Invoice</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" v-loading="loadingPage" @selection-change="selectionChange" style="width: 100%">
                <el-table-column
                    type="selection"
                    width="30">
                </el-table-column>
                <el-table-column label="APN_ID" width="100">
                    <template #default="scope">
                        {{scope.row.agent_id}}
                    </template>
                </el-table-column>
                <el-table-column label="伙伴名称">
                    <template #default="scope">
                        <div style="display:flex;align-items: center;">
                            <!-- <span style="width:190px;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" :title="scope.row.company">{{scope.row.company}}</span> -->
                            <span>{{scope.row.company}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="月份" width="100">
                    <template #default="scope">
                        {{this.formInline.month.toString().substring(0,4)+'-'+this.formInline.month.toString().substring(4,6)}}
                    </template>
                </el-table-column>
                <el-table-column label="地区" width="80">
                    <template #default="scope">
                        {{scope.row.region=='cn'?'中国':'Global'}}
                    </template>
                </el-table-column>
                <el-table-column label="PO_No.">
                    <template #default="scope">
                        {{ scope.row.company+this.formInline.month.toString().substring(0,4)+'年'+this.formInline.month.toString().substring(4,6)+'月份账单整合-'+(scope.row.region=='cn'?'中国':'Global')}}
                    </template>
                </el-table-column>
                <el-table-column label="金额" align="right" width="150">
                    <template #default="scope">
                        {{ Number(scope.row.costAgent).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="" align="right" width="20">
                </el-table-column>
            </el-table>
        </div>
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->

        <!-- 上传Invoice对话框 -->
        <el-dialog
            v-model="uploadDialogVisible"
            title="批量上传Invoice PDF"
            width="600px"
            :close-on-click-modal="false"
        >
            <el-upload
                ref="upload"
                class="upload-demo"
                drag
                action="#"
                :auto-upload="false"
                :on-change="handleFileChange"
                :on-remove="handleRemove"
                :file-list="fileList"
                accept=".pdf"
                multiple
                :limit="20"
            >
                <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                <div class="el-upload__text">将PDF文件拖到此处，或<em>点击选择</em></div>
                <template #tip>
                    <div class="el-upload__tip">支持批量上传，一次最多20个PDF文件</div>
                </template>
            </el-upload>

            <div v-if="fileList.length > 0" style="margin-top: 20px;">
                <div style="margin-bottom: 10px;">已选择 {{ fileList.length }} 个文件</div>
            </div>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="uploadDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitUpload" :loading="uploading">
                        开始上传并识别
                    </el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 上传结果对话框 -->
        <el-dialog
            v-model="resultDialogVisible"
            title="上传结果"
            width="700px"
        >
            <el-table :data="uploadResults" style="width: 100%">
                <el-table-column prop="file_name" label="文件名" width="200" />
                <el-table-column label="状态" width="100">
                    <template #default="scope">
                        <el-tag :type="scope.row.status === 'success' ? 'success' : 'danger'" size="small">
                            {{ scope.row.status === 'success' ? '成功' : '失败' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="invoice_id" label="Invoice ID" width="150" />
                <el-table-column prop="error" label="错误信息" />
            </el-table>
            
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="resultDialogVisible = false">确定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 下载整合表对话框 -->
        <el-dialog
            v-model="exportDialogVisible"
            title="下载整合表"
            width="500px"
            :close-on-click-modal="false"
        >
            <el-form :model="exportForm" label-width="100px">
                <el-form-item label="PO号" required>
                    <el-input v-model="exportForm.po" placeholder="请输入PO号" />
                </el-form-item>
                <el-form-item label="销售代表" required>
                    <el-input v-model="exportForm.sales" placeholder="请输入销售代表" />
                </el-form-item>
                <el-form-item label="代理商ID" required>
                    <el-input v-model="exportForm.agentid" placeholder="请输入代理商ID" />
                </el-form-item>
            </el-form>
            
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="exportDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="downloadIntegratedExcel" :loading="downloading">
                        下载
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {getPOList,downloadPO,downloadInvoice,getSalesList,getAgentList,getPayerList} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    import { UploadFilled } from '@element-plus/icons-vue'
    export default {
        components:{
            Pagination,
            UploadFilled
        },
        name:'poPage',
        data() {
            return {
                loading:false,
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    month:'',
                    region:'global',
                    sales:'姚菲菲',
                    agent_id:'',
                    // page: 1,
                    // limit: 20,
                },
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                tableData:[],
                salesList:[],
                agentsList:[],
                payersList:[],
                regionList:[
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                curRole:localStorage.getItem('curRole'),
                curDate:'',
                selected:[],
                // 上传相关
                uploadDialogVisible: false,
                resultDialogVisible: false,
                fileList: [],
                uploading: false,
                uploadResults: [],
                // 导出相关
                exportDialogVisible: false,
                downloading: false,
                exportForm: {
                    po: '',
                    sales: '',
                    agentid: ''
                }
            }
        },
        
        created() {
            this.permissionData();
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取当前月
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            let endD = date.getDate()<10?'0'+date.getDate():date.getDate();
            // 获取当前时间的时间戳
            this.curDate=(new Date(endY+'-'+endM+'-'+endD).getTime())/1000;
            this.formInline.month=endY+endM;
            if(localStorage.getItem('POpageForm')){
                this.formInline = JSON.parse(localStorage.getItem('POpageForm'))
            }
            var timer=null;
            if(this.curRole=='sales'){
                this.formInline.sales = localStorage.getItem('account')
                this.getData();
            }else if(this.curRole=='agent'){
                timer = setInterval(()=>{
                    if(this.payersList.length>0){
                        clearInterval(timer);
                        this.formInline.agent_id = localStorage.getItem('account');
                        this.formInline.sales = this.payersList[0].agent.sales;
                        this.getData();
                    }
                },100)
            }
        },
        methods:{
            //获取列表
            getData() {
                this.loadingPage = true
                getPOList(this.formInline).then(res => {
                    this.loadingPage = false;
                    if(res.code ==2000) {
                        this.tableData = res.data
                    }
                })
            },
            permissionData(){
                if(this.curRole=='admin'){
                    this.getAgentsList();
                    this.getSaleList();
                    this.getPayersList();
                }else if(this.curRole == 'sales'){
                    this.getAgentsList();
                    this.getPayersList();
                }else if(this.curRole == 'agent'){
                    this.getPayersList();
                }
            },
            // 获取伙伴列表
            getAgentsList(){
                getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList = res.data.data;
                    }else{
                        this.$message.error('获取伙伴列表失败！');
                    }
                })
            }, 
            // 获取销售列表
            getSaleList(){
                getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList = res.data.data;
                    }else{
                        this.$message.error('获取销售列表失败！');
                    }
                })
            },
            // 获取payer列表
            getPayersList(){
                getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList = res.data.data;
                    }else{
                        this.$message.error('获取Payer列表失败！');
                    }
                })
            }, 
            // 下载invoice
            downloadInvoiceByUrl(type){
                this.loading = true;
                if(type==1){//下载选中账单
                    var arr=[];
                    this.selected.forEach(el=>{
                        arr.push(el.agent_id)
                    })
                    downloadInvoice({agent_id:arr.join(','),month:this.formInline.month}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{//下载全部账单
                    downloadInvoice(this.formInline).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }
            },
            // 下载
            downloadFile(url){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.click()
                setTimeout(()=>{
                    a.remove()
                },1000)
            },
            // 复选框勾选
            selectionChange(val){
                this.selected=val;
            },

            downloadPOByUrl(type){
                // 月份必填校验
                if(!this.formInline.month){
                    this.$message.warning('请选择月份');
                    return;
                }
                
                this.loading = true;
                if(type==1){//下载选中账单
                    var arr=[];
                    this.selected.forEach(el=>{
                        arr.push(el.agent_id)
                    })
                    downloadPO({agent_id:arr.join(','),month:this.formInline.month,region:this.formInline.region}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    }).catch(err=>{
                        this.loading = false;
                        this.$message.error('下载失败：' + (err.message || '未知错误'));
                    })
                }else{//下载全部账单（按销售下载所有伙伴）
                    let params = {
                        month: this.formInline.month,
                        region: this.formInline.region
                    };
                    // 如果有选择销售，按销售下载
                    if(this.formInline.sales){
                        params.sales = this.formInline.sales;
                    }
                    // 如果有选择伙伴，按伙伴下载
                    if(this.formInline.agent_id){
                        params.agent_id = this.formInline.agent_id;
                    }
                    
                    downloadPO(params).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    }).catch(err=>{
                        this.loading = false;
                        this.$message.error('下载失败：' + (err.message || '未知错误'));
                    })
                }
            },
            search() {
                localStorage.setItem('POpageForm',JSON.stringify(this.formInline))
                this.getData()
            },
            reset() {
                this.formInline = {
                    month:'',
                    region:'global',
                    sales:'姚菲菲',
                    agent_id:'',
                }
                if(this.curRole=='sales'){
                    this.formInline.sales = localStorage.getItem('account')
                }else if(this.curRole=='agent'){
                    this.formInline.agent_id = localStorage.getItem('account');
                    this.formInline.sales = this.payersList[0].agent.sales
                }
                this.getData()
            },
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                this.tableHeight =  getTableHeight(tabSelectHeight)+52
            },
            // 显示上传对话框
            showUploadDialog() {
                this.uploadDialogVisible = true
            },
            // 处理文件变化
            handleFileChange(file, fileList) {
                this.fileList = fileList
            },
            // 处理文件移除
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
            // 提交上传
            async submitUpload() {
                if (this.fileList.length === 0) {
                    this.$message.warning('请选择文件')
                    return
                }

                const formData = new FormData()
                this.fileList.forEach(item => {
                    formData.append('files', item.raw)
                })

                this.uploading = true
                try {
                    const response = await this.$http.post('/bill/invoice/upload/', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    
                    if (response.data.status === 'success') {
                        this.$message.success(response.data.message)
                        this.uploadResults = response.data.results
                        this.uploadDialogVisible = false
                        this.resultDialogVisible = true
                        
                        // 清空文件列表
                        this.fileList = []
                        this.$refs.upload.clearFiles()
                    } else {
                        this.$message.error(response.data.message)
                    }
                } catch (error) {
                    this.$message.error('上传失败: ' + error.message)
                } finally {
                    this.uploading = false
                }
            },
            // 显示导出对话框
            showExportDialog() {
                this.exportDialogVisible = true
            },
            // 下载整合表
            async downloadIntegratedExcel() {
                if (!this.exportForm.po || !this.exportForm.sales || !this.exportForm.agentid) {
                    this.$message.warning('请填写完整信息')
                    return
                }

                this.downloading = true
                try {
                    const response = await this.$http.get('/bill/invoice/export/', {
                        params: this.exportForm,
                        responseType: 'blob'
                    })

                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.download = `export_${this.exportForm.po}_${Date.now()}.xlsx`
                    link.click()
                    window.URL.revokeObjectURL(url)
                    
                    this.$message.success('导出成功')
                    this.exportDialogVisible = false
                } catch (error) {
                    this.$message.error('导出失败')
                } finally {
                    this.downloading = false
                }
            },
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss">
.poPage{
    .link-dialog{
        .el-form-item__label{
            font-weight: bold;
        }
    }
    .tableSelect{
        .billMngBtn{
            margin:0;
            border:1px solid #fff;
            border-radius:0;
        }
    }
    .table{
        .el-table{
            .cell{
                .dot{
                    display: inline-block;
                    width:10px;
                    height:10px;
                    background:grey;
                    border-radius: 50%;
                    margin-right:6px;
                }
                .dot.yellow{
                    background:yellow;
                }
                .dot.orange{
                    background:orange;
                }
                .dot.green{
                    background:green;
                }
            }
        }
    }
}
</style>
